import { categoryList } from './tableColumns'
import {
	CashRegisters,
	Concepts,
	Options,
	Surcharge,
	Category,
	ContentTranslations
} from './'
import FilterComponent from './fragments/FilterComponent'
import { getCategory, listCategories, createCategory, updateCategory, updateManyCategories } from './gql'
import { File, History } from 'media/icons'
import { LIST_QUERY_LIMIT } from 'config/consts'
import HistoryModal from 'components/HistoryModal'
import { isRouteDisabled } from 'sections/utils'
import listTags from 'gql/query/listTags'

export default (t, rights) => ({
	id: '4',
	label: t('category_section.caption'),
	typename: 'Category',
	link: isRouteDisabled(rights, '4') ? null : 'schablone',
	linkDisabled: isRouteDisabled(rights, '4'),
	recordsCounter: true,
	icon: File,
	requiredFields: ['name', 'position'],
	multiEditConfig: [
		{
			fieldName: 'isActive',
			type: 'checkbox',
			label: t('common.fields.isActive')
		},
		{
			fieldName: 'isForMobileWaiter',
			type: 'checkbox',
			label: t('category_section.fields.for_mobile_waiter')
		},
		{
			fieldName: 'isLearningMode',
			type: 'checkbox',
			label: t('category_section.fields.for_learning_mode')
		},
		{
			fieldName: 'pluMode',
			type: 'checkbox',
			label: t('category_section.fields.plu_mode')
		},
		{
			fieldName: 'tagId',
			queryOptions: {
				query: listTags,
				variables: { type: 'CategoryTag' }
			},
			type: 'select',
			label: t('category_section.fields.group_tag')
		},
		{
			fieldName: 'weekDays',
			type: 'weekdayPicker',
			label: t('common.fields.week_days')
		},
		{
			fieldName: 'validAfter',
			type: 'oneDate',
			label: t('category_section.fields.valid_after')
		}
	],
	subsections: [{
		name: t('category_section.sub_sections.category'),
		link: '',
		component: Category,
		updateMutation: updateCategory.category,
		fields: ['position', 'name', 'isActive', 'isForMobileWaiter', 'isLearningMode', 'pluMode', 'dimensions', 'sortId', 'description', 'weekDays', 'validAfter', 'color', 'tagId', 'shopId', {
			fieldName: 'gridProducts',
			defaultValue: [],
			noForm: true
		}, {
			fieldName: 'img',
			noForm: true
		}]
	}, {
		name: t('common.strings.cash_register_subsection'),
		link: 'kasse',
		component: CashRegisters,
		updateMutation: updateCategory.cashRegisters,
		fields: ['cashRegisterId']
	}, {
		name: t('category_section.sub_sections.surcharge'),
		link: 'zuschlag-im-haus',
		component: Surcharge,
		updateMutation: updateCategory.surcharge,
		fields: ['surchargePercent', 'surchargeAmount', 'surchargeFrom']
	}, {
		name: t('category_section.sub_sections.options'),
		link: 'optionen',
		component: Options,
		updateMutation: updateCategory.options,
		fields: ['isNoAction', 'priceLevel', 'isActiveInHouse']
	}, {
		name: t('category_section.sub_sections.concepts'),
		link: 'konzepte',
		component: Concepts,
		updateMutation: updateCategory.concepts,
		fields: ['concepts']
	}, {
		name: t('common.strings.contentTranslations'),
		link: 'content-translations',
		component: ContentTranslations
	}],
	columns: categoryList(t),
	listQuery: listCategories,
	itemQuery: getCategory,
	createMutation: createCategory,
	addNewRecord: true,
	FilterComponent,
	newRecordsDefaults: {
		sortId: '0',
		weekDays: 127,
		isLearningMode: true,
		isForMobileWaiter: true,
		dimensions: [5, 5]
	},
	initialQueryVariables: { filter: {}, params: { sort: [{ field: 'position', order: 'ASC' }], limit: LIST_QUERY_LIMIT, cursors: { limit: LIST_QUERY_LIMIT } } },
	sideListProps: {
		datatableProps: {
			defaultSorted: [{
				id: 'position'
			}]
		}
	},
	contextTypes: {
		searchCR: 'string'
	},
	multiEditMutation: updateManyCategories,
	itemActions: [{
		label: t('product_section.strings.update_group'),
		action: ({ multiEdit, data }) => multiEdit.setIsActive(!multiEdit.isActive, data.id)
	}, {
		label: t('common.strings.history'),
		Icon: History,
		modalComponent: HistoryModal
	}]
})
